/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const adults_misc : {[key: string]: Array<[string, string]>} = {
};
